<template>
  <svg width="38" height="44" viewBox="0 0 38 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.9398 37.3515C32.0381 35.177 38 27.7848 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 27.7848 5.96187 35.1771 14.0602 37.3515L18.9999 44L23.9398 37.3515Z" fill="#231F20"/>
    <path d="M12 10V30" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M26 10V30" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M19 10V14" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M19 18V22" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M19 26V30" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: 'PanoramaIconRoad'
}
</script>

<style scoped>

</style>
